import React, { useState, useEffect } from 'react';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import PopUp from '../../../../common/components/PopUp/PopUp';
import initialImg from '../../../../images/icons/upload_new.svg';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import CircularLoading from '../../../../common/components/CircularLoading/CircularLoading';
import { getSellerDetails } from '../../../../common/constants/api';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';
import styles from './Seller.module.css';
import CommonSellerProfession from './CommonSellerProfession';
import salary_icon from '../../../../images/icons/salary_icon.svg';
import self_Employed_Professional from '../../../../images/icons/self_Employed_Professional.svg';
import self_Employed from '../../../../images/icons/self_Employed.svg';

const serverData = [
  {
    imgUrl: salary_icon,
    profession: 'Salaried',
    value: 'SALARIED'
  },
  {
    imgUrl: self_Employed,
    profession: 'Self Employed',
    value: 'SELF_EMPLOYED'
  },
  {
    imgUrl: self_Employed_Professional,
    profession: (
      <div
        className="md:flex md:flex-col md:w-56 md:relative"
        style={{
          left: '-45px'
        }}
      >
        <div>Self Employed Professional </div>
        <span className="text-black-600"> Doctor | CA | Architect</span>
      </div>
    ),
    value: 'SELF_EMPLOYED_PROFESSIONAL'
  }
];

let bgAndTextColors = [
  {
    bgcolor: '#E8F8F5',
    textcolor: '#048B95'
  },
  {
    bgcolor: '#FCF6E6',
    textcolor: '#B16B17'
  },
  {
    bgcolor: '#F9F0F0',
    textcolor: '#D6583E'
  }
];

const IndividualSeller = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  handleSubmit,
  setFieldTouched,
  setFieldError,
  isSubmitting,
  lead_Id,
  loanTypeId,
  getAgreementDoc,
  editAgreementDoc,
  setEditAgreeDoc,
  getDeedDoc,
  setEditDeedDoc,
  editDeedDoc
}) => {
  const { seller_container } = styles;
  const [showRadio, setShowRadio] = useState('');
  const [isGetOver, setIsGetOver] = useState(false);
  function handleSelectData(anyselected, index) {
    setFieldValue('professionType', anyselected.value);
    setShowRadio(index);
  }
  //get
  useEffect(() => {
    getSellerDetails(lead_Id, loanTypeId)
      .then(res => {
        setFieldValue('sellerName', res.firstName);
        setFieldValue('professionType', res.professionType);
        setIsGetOver(true);
      })
      .catch(err => {
        setIsGetOver(true);
      });
  }, []);

  useEffect(() => {
    if (values.professionType === 'SALARIED') setShowRadio(0);
    if (values.professionType === 'SELF_EMPLOYED') setShowRadio(1);
    if (values.professionType === 'SELF_EMPLOYED_PROFESSIONAL') setShowRadio(2);
  }, [values.professionType]);
  return isGetOver ? (
    <div className={`${seller_container} md:bg-white`}>
      <div className="mb-10 mt-4">
        <CommonInput
          name="sellerName"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.sellerName}
          stylesContainer={{
            maxWidth: '320px'
          }}
          legendName="Seller Name "
          error={touched.sellerName && errors.sellerName}
          errorMsg={errors.sellerName}
          touched={touched.sellerName}
        />
      </div>
      {/* /////////upload */}
      <div className="flex  justify-center md:justify-start md:flex-wrap">
        {getDeedDoc && !editDeedDoc ? (
          <div className="ml-2 mt-2">
            <p className="mb-3 text-grey-50">Sale Deed</p>
            <ShowGetImage img={getDeedDoc} setEdit={setEditDeedDoc} />
          </div>
        ) : (
          <div className="mr-4">
            <p className="pb-4">Upload Sale Deed</p>
            <div
              className="bg-white  rounded-lg border border-navy-200 md:border-none
            py-9 pl-11 pr-5 md:py-0 md:pl-0 md:pr-0
            "
            >
              <GlobalUploadComp
                data={values}
                imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                setFieldError={setFieldError}
                initialImg={initialImg} // initial image
                subInst="Click here to upload"
                subtext="CHOOSE FILE"
              />
            </div>
          </div>
        )}
        {getAgreementDoc && !editAgreementDoc ? (
          <div className="ml-2 mt-2">
            <p className="mb-3 text-grey-50">Sale Agreement</p>
            <ShowGetImage img={getAgreementDoc} setEdit={setEditAgreeDoc} />
          </div>
        ) : (
          <div>
            <p className="pb-4">Upload Sale Agreement</p>
            <div
              className="bg-white  rounded-lg border border-navy-200 md:border-none
            py-9 pl-11 pr-5 md:py-0 md:pl-0 md:pr-0"
            >
              <GlobalUploadComp
                data={values}
                imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                setFieldError={setFieldError}
                initialImg={initialImg} // initial image
                subInst="Click here to upload"
                subtext="CHOOSE FILE"
              />
            </div>
          </div>
        )}
      </div>
      <div>
        <p className="text-black-850 font-medium font-roboto text-base p-4">
          Choose Seller Profession
        </p>
        <div className="md:flex flex-wrap">
          {serverData.map((each, index) => {
            return (
              <CommonSellerProfession
                showRadio={showRadio}
                serialNo={index}
                key={each.profession}
                sendUrl={each.imgUrl}
                sendloanType={each.profession}
                randomColor={bgAndTextColors[index]}
                handleSelectData={() => {
                  handleSelectData(each, index);
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  ) : (
    <div className={'w-full mt-10 mx-auto'}>
      <CircularLoading />
    </div>
  );
};

export default IndividualSeller;
